import { Button } from "@mui/material";
import { uiNeutrals } from "../../constants/uiNeutrals";
import useSpamProtection from "../../hooks/useSpamProtection";

function CustomButton({
  children,
  onClick,
  sx,
  disabled,
  variant = "primary",
  preventSpam = true, // New prop to control spam protection
  spamDelay = 1000, // New prop to control delay
  type, // Extract type prop
  ...props
}) {
  const { isDisabled, handleClick } = useSpamProtection(spamDelay);

  // For submit buttons, disable spam protection to allow proper form submission
  const shouldPreventSpam = preventSpam && type !== "submit";

  const handleButtonClick = (event) => {
    if (shouldPreventSpam) {
      handleClick(() => onClick?.(event));
    } else {
      onClick?.(event);
    }
  };

  const isButtonDisabled = disabled || (shouldPreventSpam && isDisabled);

  // Primary variant (black background)
  const primaryStyles = {
    backgroundColor: isButtonDisabled ? "#d1d5db" : "black",
    color: isButtonDisabled ? "#666" : "white",
    "&:hover": {
      backgroundColor: isButtonDisabled ? "#d1d5db" : "#333",
    },
  };

  // Secondary variant (light gray background)
  const secondaryStyles = {
    backgroundColor: isButtonDisabled ? "#d1d5db" : uiNeutrals.surface,
    color: isButtonDisabled ? "#999" : "#111827",
    "&:hover": {
      backgroundColor: isButtonDisabled ? "#d1d5db" : uiNeutrals.surfaceHover,
    },
  };

  const variantStyles =
    variant === "secondary" ? secondaryStyles : primaryStyles;

  return (
    <Button
      onClick={handleButtonClick}
      disabled={isButtonDisabled}
      type={type} // Pass through the type prop
      sx={{
        ...variantStyles,
        borderRadius: "60px",
        paddingX: 2.5,
        paddingY: 1.25,
        textTransform: "none",
        fontWeight: 600,
        cursor: isButtonDisabled ? "not-allowed" : "pointer",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

export default CustomButton;
